import React from 'react';
import Card from '../../components/BaseComponents/Card';
import './DeleteAccount.scss';
import TextInput from '../../components/BaseComponents/TextInput';
import Button from '../../components/BaseComponents/Button';
import { emailRegexp } from '../../utils/constants';

type Props = {};

const DeleteAccount = (props: Props) => {
  const [email, setEmail] = React.useState('');
  const [isLoading, setIsLoading] = React.useState(false);
  const [error, setError] = React.useState('');
  const [isSubmitted, setIsSubmitted] = React.useState(false);

  const onSubmit = () => {
    setIsLoading(true);
    // Make API call to delete account
    console.log('email :>> ', email);

    if (!emailRegexp.test(email)) {
      setError('Invalid email address');
      setIsLoading(false);
      return;
    }

    setTimeout(() => {
      setIsLoading(false);
      setIsSubmitted(true);
    }, 1000);
  };

  const onChange = (e: any) => {
    if (error) setError('');
    setEmail(e.target.value);
  };

  return (
    <Card backgroundColor='#F7F9FC' padding={'0'}>
      <div className='delete-acc-container'>
        {isSubmitted ? (
          <div className='success-message'>
            <div className='form-header'>Success!</div>
            <div className='desc'>
              Your account has been successfully purged from our systems. All
              associated data, including past purchases and saved information,
              has been deleted.
              <br />
              <br />
              Thank you for using our services!
            </div>
          </div>
        ) : (
          <>
            <div className='form-header'>Account Purge</div>
            <div className='desc'>
              <b>WARNING:</b> This will delete all of your account information
              from our systems, including past purchases, profile pictures, and
              any other saved information. This action can not be undone.
              <br />
              If you are sure you want to do this, please provide your email.
            </div>
            <br />
            <TextInput
              placeholder={'Please provide your email'}
              name={'email'}
              onChange={onChange}
              isError={!!error}
              errorMessage={error}
            />
            <div className='btn-wrapper'>
              <Button
                text='Delete account'
                isDisabled={!email}
                isLoading={isLoading}
                onClick={onSubmit}
              />
            </div>
          </>
        )}
      </div>
    </Card>
  );
};

export default DeleteAccount;
